import { useState, useEffect } from 'react';
import classNames from 'classnames';

function ChoiceValance({ modelTop, setModelValance, setModelFringe }) {
	const [activeIndex, setActiveIndex] = useState(null);

	const handleModelSelection = (item, index) => {
		if (activeIndex === index) {
			setActiveIndex(null);
			setModelValance({});
			setModelFringe({});
			return;
		}

		setActiveIndex(index);
		setModelValance(() => item);
	}

	useEffect(() => {
		setActiveIndex(null);// reset selected item on change modelTop
		setModelValance({});// reset Model Valance on change modelTop
		setModelFringe({});// reset Model Valance on change modelTop
	}, [modelTop]);

	if (!!!modelTop.valance) {
		return null;
	}

	return (
		<div className="choices">
			<ul>
				{modelTop.valance.list.map((item, index) => {
					// console.log(item.id);
					// console.log(modelTop.colors);
					return (
						<li key={index}>
							<a
								onClick={(e) => {
									e.preventDefault();
									handleModelSelection(item, index)
								}}
								className={classNames('preview decor-checkbox', { 'is-active': activeIndex === index })}
								href={item.model}
							>
								<picture className="preview__media">
									<img src={item.preview} alt={item.name} />
								</picture>

								<div className="preview__content">
									<h6>{item.name}</h6>
								</div>
							</a>
						</li>
					)
				})}
			</ul>
		</div>
	);
}

export default ChoiceValance;